/* global $, _, intlTelInputUtils */

$(function() {
    "use strict";

    var $root = $('.tel-input');

    function init ($input) {
        var options = $input.data();

        if (!options.plugin_intlTelInput) {

            if (!options.defaultCountry) {
                options.defaultCountry = 'auto';
            }

            $input
                .intlTelInput(options)
                .parent().find('.flag-dropdown').remove();

            $input.on('TelInput::ChangeCountryPrefix', function (event, iso) {
                changeCountryPrefix($input, iso);
            });

            listenToCoutryChange($input);
        }
    }

    function initAll () {
        $root = $('.tel-input');

        $root.each(function() {
            init($(this));
        });
    }

    function changeCountryPrefix ($input, iso) {
        $input.off('keyup.TelInput::ChangeCountryPrefix');

        function isEmpty () {
            return (_($input.val()).trim() === '') || (_($input.val()).trim() === '+');
        }

        if (isEmpty()) {
            $input.intlTelInput('selectCountry', iso);
        }
        else {
            $input.on('keyup.TelInput::ChangeCountryPrefix', function() {

                if (isEmpty()) {
                    $input
                        .off('keyup.TelInput::ChangeCountryPrefix')
                        .intlTelInput('selectCountry', iso);
                }
            });
        }
    }

    function listenToCoutryChange ($input) {
        var $form = $input.parents('form');

        if ( Boolean($form.length > 0) ) {
            $form
                .off('CitySelector::Change.TelInput')
                .on('CitySelector::Change.TelInput', function (event, country) {
                    if ( !_(country.iso).isUndefined() ) {
                        changeCountryPrefix($input, country.iso);
                    }
                });
        }
    }

    $(document).on('ready TelInput::InitAll', function() {
        initAll();
    });

    // Custom parsley validator

    if (!_(window.ParsleyValidator).isUndefined() && !_(window.intlTelInputUtils.isValidNumber).isUndefined()) {

        window.ParsleyValidator
            .addValidator('phone', function (value) {
                return intlTelInputUtils.isValidNumber(value);
            }, 32)
            .addMessage('ru', 'phone', 'Неправильно набран номер');
    }
});